module.exports = __webpack_public_path__ + "static/media/sigma.2e294dce.png";